<template>
    <p><a href="mailto:info@batnorton.com" class="article__link">info@batnorton.com</a></p>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
